import { render, staticRenderFns } from "./select-nation.vue?vue&type=template&id=6caa5566&"
import script from "./select-nation.vue?vue&type=script&lang=js&"
export * from "./select-nation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports